import { Navigate, Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { NotificationsDrawer } from "@/features/notifications/NotificationsDrawer";
import { useAuthStore } from "@/features/auth/auth.store";

export function AppShell() {
  const status = useAuthStore((s) => s.status);

  if (status === "anonymous") {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Topbar />
        <main className="flex-1 overflow-y-auto overflow-x-hidden scroll-thin">
          <Outlet />
        </main>
      </div>
      <NotificationsDrawer />
    </div>
  );
}
